/**
 * @flow
 * @relayHash 7c19ab74dfa9c8a996ff6539d94fb348
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ArticleStateType = "available" | "deleted" | "draft" | "%future added value";
export type actionsArticleQueryVariables = {|
  id: string
|};
export type actionsArticleQueryResponse = {|
  +viewer: ?{|
    +article: ?{|
      +id: string,
      +title: ?string,
      +previewPicture: ?string,
      +foreignAgent: ?boolean,
      +previewAttribution: ?string,
      +body: ?string,
      +bodyHtml: ?string,
      +lead: ?string,
      +section: ?string,
      +category: ?string,
      +topics: ?$ReadOnlyArray<?{|
        +id: string,
        +name: ?string,
      |}>,
      +linkedArticles: ?$ReadOnlyArray<?{|
        +id: string,
        +title: ?string,
      |}>,
      +author: ?string,
      +hidden: ?boolean,
      +yaGenre: ?string,
      +isEvent: ?boolean,
      +infostring: ?boolean,
      +infostring_hot: ?boolean,
      +showInYandexNews: ?boolean,
      +showInYandexZen: ?boolean,
      +availableAt: ?string,
      +seoTitle: ?string,
      +seoDescription: ?string,
      +seoKeywords: ?string,
      +preview: ?{|
        +id: string,
        +filename: ?string,
        +description: ?string,
      |},
      +combinedPreviewVideo: ?{|
        +id: string,
        +filename: ?string,
        +description: ?string,
      |},
      +mediaFiles: ?$ReadOnlyArray<?{|
        +id: string
      |}>,
      +state: ArticleStateType,
      +mainPageOrder: number,
    |}
  |}
|};
export type actionsArticleQuery = {|
  variables: actionsArticleQueryVariables,
  response: actionsArticleQueryResponse,
|};
*/


/*
query actionsArticleQuery(
  $id: ID!
) {
  viewer {
    article(id: $id) {
      id
      title
      previewPicture
      foreignAgent
      previewAttribution
      body
      bodyHtml
      lead
      section
      category
      topics {
        id
        name
      }
      linkedArticles {
        id
        title
      }
      author
      hidden
      yaGenre
      isEvent
      infostring
      infostring_hot
      showInYandexNews
      showInYandexZen
      availableAt
      seoTitle
      seoDescription
      seoKeywords
      preview {
        id
        filename
        description
      }
      combinedPreviewVideo {
        id
        filename
        description
      }
      mediaFiles {
        id
      }
      state
      mainPageOrder
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = [
  v1,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "filename",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  }
],
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "article",
  "storageKey": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id",
      "type": "ID"
    }
  ],
  "concreteType": "Article",
  "plural": false,
  "selections": [
    v1,
    v2,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "previewPicture",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "foreignAgent",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "previewAttribution",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "body",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "bodyHtml",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lead",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "section",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "category",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "topics",
      "storageKey": null,
      "args": null,
      "concreteType": "Topic",
      "plural": true,
      "selections": [
        v1,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkedArticles",
      "storageKey": null,
      "args": null,
      "concreteType": "Article",
      "plural": true,
      "selections": [
        v1,
        v2
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "author",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hidden",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "yaGenre",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isEvent",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "infostring",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "infostring_hot",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showInYandexNews",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showInYandexZen",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "availableAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "seoTitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "seoDescription",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "seoKeywords",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "preview",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaFile",
      "plural": false,
      "selections": v3
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "combinedPreviewVideo",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaFile",
      "plural": false,
      "selections": v3
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "mediaFiles",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaFile",
      "plural": true,
      "selections": [
        v1
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "state",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mainPageOrder",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "actionsArticleQuery",
  "id": null,
  "text": "query actionsArticleQuery(\n  $id: ID!\n) {\n  viewer {\n    article(id: $id) {\n      id\n      title\n      previewPicture\n      foreignAgent\n      previewAttribution\n      body\n      bodyHtml\n      lead\n      section\n      category\n      topics {\n        id\n        name\n      }\n      linkedArticles {\n        id\n        title\n      }\n      author\n      hidden\n      yaGenre\n      isEvent\n      infostring\n      infostring_hot\n      showInYandexNews\n      showInYandexZen\n      availableAt\n      seoTitle\n      seoDescription\n      seoKeywords\n      preview {\n        id\n        filename\n        description\n      }\n      combinedPreviewVideo {\n        id\n        filename\n        description\n      }\n      mediaFiles {\n        id\n      }\n      state\n      mainPageOrder\n    }\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "actionsArticleQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v4
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "actionsArticleQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v4,
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4f20508f6cbf374314cf5f0a17f9f733';
module.exports = node;



// WEBPACK FOOTER //
// src/components/articles/columns/__generated__/actionsArticleQuery.graphql.js